// extracted by mini-css-extract-plugin
export default {"uikit-overflow__trigger":"uikit-overflow__trigger__7XsTE"};